export class SpinnerShort {
  name: string;
  show: boolean;

  constructor(initValue?: Partial<SpinnerShort>) {
    Object.assign(this, initValue);
  }
}

export class Spinner extends SpinnerShort {
  class: string;
  fullScreen: boolean;
  gif: string;

  constructor(initValue?: Partial<Spinner>) {
    super(initValue ? {name: initValue.name, show: initValue.show} : {});
    Object.assign(this, initValue);
  }
}
